import { Link } from 'react-router-dom';
import './side.css';
import { useState } from 'react';

export default function Sidebar() {
  const [isCollapsed] = useState(false);
  return (
    <>
      <div className="app-side-nav-glocre">
        <div
          id="sidenav"
          className={`sidenav ${isCollapsed ? 'is-collapsed' : ''}`}
        >
          <header className=" bg-white" style={{ borderRadius: '15px' }}>
            <div className="sidebar-logo">
              <Link to="/">
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <img
                    src={require('../../images/procure-g-logo.png')}
                    className="w-75"
                    alt="glocre"
                  />
                </div>
              </Link>
            </div>
          </header>
          <div className="nav__divider"></div>
          <div className="sidenav__nav ">
            <ul className="nav__list">
              <Link to="/admin/dashboard">
                <li className="nav__item is-active">
                  <button className="nav__button">
                    <span className="nav__icon">
                      <i className="fa fa-chart-line"></i>
                    </span>
                    <span className="nav__label">Dashboard</span>
                  </button>
                </li>
              </Link>

              <Link to="/admin/products">
                <li className="nav__item is-active">
                  <button className="nav__button">
                    <span className="nav__icon">
                      <i className="fa fa-box-open"></i>
                    </span>
                    <span className="nav__label">Product List</span>
                  </button>
                </li>
              </Link>

              <Link to="/admin/products/create">
                <li className="nav__item is-active">
                  <button className="nav__button">
                    <span className="nav__icon">
                      <i className="fa fa-plus-square"></i>
                    </span>
                    <span className="nav__label">Create Products</span>
                  </button>
                </li>
              </Link>

              <Link to="/admin/orders">
                <li className="nav__item is-active">
                  <button className="nav__button">
                    <span className="nav__icon">
                      <i className="fa fa-shopping-cart"></i>
                    </span>
                    <span className="nav__label">Orders List</span>
                  </button>
                </li>
              </Link>

              <Link to="/admin/users">
                <li className="nav__item is-active">
                  <button className="nav__button">
                    <span className="nav__icon">
                      <i className="fa fa-users"></i>
                    </span>
                    <span className="nav__label">Users</span>
                  </button>
                </li>
              </Link>

              <Link to="/admin/reviews">
                <li className="nav__item is-active">
                  <button className="nav__button">
                    <span className="nav__icon">
                      <i className="fa fa-star"></i>
                    </span>
                    <span className="nav__label">Reviews</span>
                  </button>
                </li>
              </Link>

              <Link to="/admin/edit-banner">
                <li className="nav__item is-active">
                  <button className="nav__button">
                    <span className="nav__icon">
                      <i className="fa fa-images"></i>
                    </span>
                    <span className="nav__label">Banner</span>
                  </button>
                </li>
              </Link>

              <Link to="/admin/awsimages">
                <li className="nav__item is-active">
                  <button className="nav__button">
                    <span className="nav__icon">
                      <i className="fa fa-image"></i>
                    </span>
                    <span className="nav__label">Images</span>
                  </button>
                </li>
              </Link>

              <Link to="/admin/subscribers">
                <li className="nav__item is-active">
                  <button className="nav__button">
                    <span className="nav__icon">
                      <i className="fa fa-envelope-open-text"></i>
                    </span>
                    <span className="nav__label">All Emails</span>
                  </button>
                </li>
              </Link>

              <Link to="/admin/announcements">
                <li className="nav__item is-active">
                  <button className="nav__button">
                    <span className="nav__icon">
                      <i className="fa fa-bullhorn"></i>
                    </span>
                    <span className="nav__label">Announcements List</span>
                  </button>
                </li>
              </Link>

              <Link to="/admin/createAnnouncements">
                <li className="nav__item is-active">
                  <button className="nav__button">
                    <span className="nav__icon">
                      <i className="fa fa-bullhorn"></i>
                    </span>
                    <span className="nav__label">Create Announcement</span>
                  </button>
                </li>
              </Link>

              <Link to="/admin/Announcementsbanner">
                <li className="nav__item is-active">
                  <button className="nav__button">
                    <span className="nav__icon">
                      <i className="fa fa-bullhorn"></i>
                    </span>
                    <span className="nav__label">Announcement Banner</span>
                  </button>
                </li>
              </Link>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}
